import { Box, DialogContent, DialogTitle, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

import CustomizedCircularProgress from '@/components/shared/customized-circular-progress';
import { FC } from 'react';
import { pxToRem } from '@/theme/typography';
import shallow from 'zustand/shallow';
import { useDialog } from '@/logic/state/dialog';
import { useGetDynamicPage } from '@/logic/services/dynamic-pages';
import { BackwardButton } from '../shared/backward-button';
import ImageBoxFuture from '../shared/image-box-future';

export const TermsAndConditionsForm: FC = () => {
  const dialog = useDialog(s => s.dialog, shallow);
  const intl = useIntl();
  const { data, isLoading } = useGetDynamicPage({
    query: { type: 'TERMS_AND_CONDITIONS' },
  });

  return (
    <>
      <DialogTitle>
        <BackwardButton
          handleClick={dialog?.termsAndConditionsFormPayload?.handleBackwardClick}
        />
      </DialogTitle>
      <DialogContent id='terms-conditions-form'>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '90%',
            margin: 'auto',
          }}
        >
          <Typography
            sx={{
              textAlign: 'center',
              mt: '26px',
              fontWeight: 700,
              fontSize: {
                mobile: '18px',
                tablet: pxToRem(20),
              },
              lineHeight: '30px',
            }}
          >
            <FormattedMessage id='terms.and.conditions' />
          </Typography>{' '}
          <Box sx={{ width: 96, height: 96, marginBlock: 4, position: 'relative' }}>
            {data?.photoUrl && (
              <ImageBoxFuture
                img={data?.photoUrl as string}
                title={intl.formatMessage({
                  id: 'alt.terms_and_conditions',
                })}
                objectFit='contain'
                sx={{
                  width: '96px',
                  height: '96px',
                }}
              />
            )}
          </Box>
        </Box>
        <Box sx={{ marginBlockEnd: 5 }}>
          <Typography
            component='div'
            dangerouslySetInnerHTML={{ __html: data?.content as string }}
          ></Typography>
        </Box>
        {isLoading && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: 'auto',
              marginBlock: 3,
            }}
          >
            <CustomizedCircularProgress />
          </Box>
        )}
      </DialogContent>
    </>
  );
};
